import React from "react";

const Error = (props) => (
  <p style={{ color: "#ff2f2f" }} className={props.className}>
    {props.children}
  </p>
);

export default Error;
